import request from "@/utils/request";
export const login = data => {
    return request.request({
        url: "/m/common/member/mingsheng/ssoLogin",
        method: "POST",
        data,
    });
};
export const testLogin = data => {
    return request.request({
        url: "/member/login",
        method: "POST",
        data,
    });
};